import { Visibility } from '@mui/icons-material'
import { Box, FormControlLabel, Switch, Tooltip } from '@mui/material'
import { CriteriaPanel } from '../criteria'
import { useAdventureEditorStore } from '../../../stores/adventureEditorStore'

export function DisplayCriteriaPanel() {
  const adventureId = useAdventureEditorStore((state) => state.adventureId)
  const useDisplayForJoining = useAdventureEditorStore((state) => state.useDisplayForJoining)
  const setUseDisplayForJoining = useAdventureEditorStore((state) => state.setUseDisplayForJoining)

  return (
    <CriteriaPanel
      type="display"
      title="Display Criteria"
      description="Control who can see this adventure based on conditions"
      icon={<Visibility />}
      adventureId={adventureId}
      headerAction={
        <Tooltip title="When enabled, users who can see this adventure will also be able to join it">
          <FormControlLabel
            control={
              <Switch
                checked={useDisplayForJoining}
                onChange={(e) => setUseDisplayForJoining(e.target.checked)}
                size="small"
              />
            }
            label={
              <Box component="span" sx={{ fontSize: '0.875rem' }}>
                Also use for join
              </Box>
            }
            sx={{ mr: 0 }}
          />
        </Tooltip>
      }
    />
  )
}
